const initialState = {
    flightData: null,
    intFlightData: null,
    ticketSort: null,
    ticketSelectedFilters: null,
    hotelData: null,
    hotelSort: null,
    hotelSelectedFilters: null,
    itineraryList: null,
    tourList: null,
    selectedTicket: null,
};

export default initialState;
